module.exports = "/davinci/assets/8a56b824302d71840dbd2c38f2f3b32f.png";